import { useState } from "react";

import Select from "components/Select";
import { convertPaymentSpeedOption } from "helpers/convertFormData";
import { IOption } from "models/Form";
import { IInvitedGroup } from "models/User";
import styles from "./style.module.scss";

interface IProps {
  type: "pending" | "connected";
  data: IInvitedGroup;
}

export default function InvitedGroupItem({ type, data }: Readonly<IProps>) {
  const [selectedPaymentSpeed, setSelectedPaymentSpeed] = useState(
    type === "connected" ? data.payment_speed_options.find((speed) => speed.is_default) : undefined
  );

  const onChangePaymentSpeed = (paymentSpeed: IOption) => {
    setSelectedPaymentSpeed(
      data.payment_speed_options.find((speed) => speed.payout_days === paymentSpeed.id)
    );
  };

  return (
    <ul className={styles.invitedGroupItemContainer}>
      <li>
        <span className="font-bold">Broker</span>
        <span className={styles.data}>{data.group_data.group_name}</span>
      </li>
      <li>
        <span className="font-bold">Email</span>
        <span className={styles.data}>{data.group_data.company_email}</span>
      </li>
      <li>
        <span className="font-bold">Phone</span>
        <span className={styles.data}>{data.group_data.company_phone_number}</span>
      </li>
      <li>
        <span className="font-bold">MC #</span>
        <span className={styles.data}>{data.group_data.company_mc}</span>
      </li>
      <li>
        <span className="font-bold">DOT #</span>
        <span className={styles.data}>{data.group_data.company_dot}</span>
      </li>
      {type === "connected" ? (
        <>
          <li>
            <span className="font-bold">Payment Speed</span>
          </li>
          <li className="gap-4">
            <Select
              options={data.payment_speed_options.map((option) =>
                convertPaymentSpeedOption(option)
              )}
              value={
                selectedPaymentSpeed ? convertPaymentSpeedOption(selectedPaymentSpeed) : undefined
              }
              onChange={onChangePaymentSpeed}
              btnClass="!py-2 !pl-2 !pr-4"
              className="w-full col-span-2 text-xs"
              arrowClass="!right-0"
              dropdownClass="!p-2 !flex"
              disabled
            />
          </li>
        </>
      ) : null}
    </ul>
  );
}
